import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { getPermissionList, createRole, editRole, getDetailPermissionList, enableRole, disableRole } from '@blade-sxp/account/api/role';
let default_1 = class default_1 extends Vue {
    addDialogVisible;
    dialogVisible = false; // this.addDialogVisible;
    roleName = '';
    switchValue = false;
    readValue = false;
    allSelect = false;
    roleArr = [];
    effectCheckbox = [];
    parentEffectCheckbox = [];
    defaultProps = {
        children: 'subPermissions',
        label: 'name',
    };
    data = [];
    editData = [];
    changeAdddialog(bool) {
        if (bool) {
            this.getPermissionData();
        }
        else {
            this.allSelect = false;
        }
        this.dialogVisible = bool;
        this.roleName = '';
    }
    // 处理上送数据
    getFinallyData(data) {
        data.forEach((item, index) => {
            if (item.subPermissions.length) {
                this.getFinallyData(item.subPermissions);
            }
            let enableArr = [];
            item.roleEnables.forEach((ele, index) => {
                // 顺序固定
                if (ele.status !== 'disable') {
                    enableArr.push(ele.status);
                    item.otherPermissionJson.buttonPermissions[index].buttonPermissionStatus = ele.status
                        ? 'BUTTON_PERMISSIONS_TRUE'
                        : 'BUTTON_PERMISSIONS_FALSE';
                }
            });
            item.enable = enableArr.some((item) => item);
        });
        return data;
    }
    async submit() {
        // 处理上送数据
        this.data = this.getFinallyData(this.data);
        let editId = this.$attrs.editId;
        let mode = this.$attrs.openMode;
        let params = {
            demo_role: false,
            role_name: this.roleName,
            permissions: this.data,
            id: '',
        };
        if (mode === 'edit') {
            params.id = editId;
        }
        if (!params.role_name) {
            this.$message({
                type: 'error',
                message: this.$t('roleName'),
                customClass: 'zZindex',
            });
            return;
        }
        try {
            await (mode === 'add' ? createRole(params) : editRole(params)).then((res) => {
                this.$message({
                    message: mode === 'add' ? this.$t('addSuccessfully') : this.$t('editSuccessfully'),
                    type: 'success',
                });
                this.$emit('update:addDialogVisible', false);
                this.$parent?.$parent.getData({});
                this.$parent.searchValue = '';
                this.$parent.statusValue = '';
            });
        }
        catch (e) {
            // this.$message({ type: 'error', message: e });
        }
    }
    // 递归函数
    platform(node) {
        if (!node.parent) {
            return;
        }
        this.effectCheckbox.push(node.data.code);
        // 调用递归
        this.platform(node.parent);
    }
    // 获取受影响的checkbox code
    getEffectCheckbox(node) {
        node.forEach((item) => {
            if (item.childNodes.length) {
                this.getEffectCheckbox(item.childNodes);
            }
            this.effectCheckbox.push(item.data.code);
        });
    }
    // 更改影响的子checkbox状态
    updateEffectCheckbox(data, index, bool) {
        data.forEach((element) => {
            if (element.subPermissions.length) {
                this.updateEffectCheckbox(element.subPermissions, index, bool);
            }
            this.effectCheckbox.forEach((code) => {
                if (code === element.code) {
                    element.roleEnables.forEach((roleItem, roleIndex) => {
                        if (bool) {
                            if (roleIndex === index) {
                                if (element.roleEnables[roleIndex].status !== 'disable') {
                                    element.roleEnables[roleIndex].status = bool;
                                }
                            }
                            else {
                                if (element.roleEnables[roleIndex].status !== 'disable') {
                                    element.roleEnables[roleIndex].status = !bool;
                                }
                            }
                        }
                        else {
                            if (roleIndex === index) {
                                if (element.roleEnables[roleIndex].status !== 'disable') {
                                    element.roleEnables[roleIndex].status = bool;
                                }
                            }
                        }
                    });
                }
            });
        });
        return data;
    }
    // 判断父节点下的子节点是否都选中
    isAll(code, data, index) {
        let isAllSelect = [];
        let flag;
        let newArr = this.flag(data);
        newArr.forEach((element) => {
            if (element.code.startsWith(code) && element.code !== code) {
                if (element.roleEnables[index].status !== 'disable') {
                    isAllSelect.push(element.roleEnables[index].status);
                }
            }
        });
        flag = isAllSelect.every((item) => item);
        return flag;
    }
    // 更改影响的父checkbox状态
    updateParentEffectCheckbox(data, index, bool) {
        data.forEach((element) => {
            if (element.subPermissions.length) {
                this.updateParentEffectCheckbox(element.subPermissions, index, bool);
            }
            this.effectCheckbox.forEach((code) => {
                if (code === element.code) {
                    if (bool) {
                        // 判断当前受影响的父节点下面的子节点是否都被选中 不是则横杠 全选中则为对勾
                        // element.roleEnables有一key值为isall的返回值 控制当前checkbox的横杠和对勾
                        if (element.roleEnables[index].status !== 'disable') {
                            element.roleEnables[index].status = bool;
                            element.roleEnables.forEach((item, roleIndex) => {
                                item.isAll = this.isAll(code, data, roleIndex);
                                if (roleIndex !== index && item.status !== 'disable') {
                                    item.status = !this.isNone(code, data, roleIndex);
                                }
                            });
                        }
                    }
                    else {
                        // 父节点变成横杠
                        element.roleEnables[index].isAll = this.isAll(code, data, index);
                        // 子节点都不选 父节点取消选中
                        element.roleEnables.forEach((item, roleIndex) => {
                            if (item.status !== 'disable') {
                                item.status = !this.isNone(code, data, roleIndex);
                            }
                        });
                    }
                }
            });
        });
        return data;
    }
    // 根据所有子节点的状态 如果子节点都没有选中 那么父节点取消选中
    isNone(code, data, index) {
        let isAllSelect = [];
        let flag;
        let newArr = this.flag(data);
        newArr.forEach((element) => {
            if (this.isTrue(code, element, index)) {
                isAllSelect.push(element.roleEnables[index].status);
            }
        });
        flag = isAllSelect.every((item) => !item);
        return flag;
    }
    isTrue(code, element, index) {
        return element.code.startsWith(code) && element.code !== code && element.roleEnables[index].status !== 'disable';
    }
    // 勾选事件
    changeNodeCheck(node, index, bool) {
        this.allSelect = false;
        let selectNode = this.$refs.tree.getNode(node);
        let newData = [...this.data];
        this.effectCheckbox = [];
        // 单选
        node.data.roleEnables.forEach((element, nodeIndex) => {
            if (bool) {
                if (nodeIndex === index) {
                    if (node.data.roleEnables[nodeIndex].status !== 'disable') {
                        node.data.roleEnables[nodeIndex].status = bool;
                    }
                }
                else {
                    if (node.data.roleEnables[nodeIndex].status !== 'disable') {
                        node.data.roleEnables[nodeIndex].status = !bool;
                    }
                }
            }
        });
        if (node.childNodes.length) {
            this.getEffectCheckbox(node.childNodes);
            this.data = this.updateEffectCheckbox(newData, index, bool);
        }
        this.platform(selectNode);
        this.data = this.updateParentEffectCheckbox([...this.data], index, bool);
    }
    // 全选事件
    selectAll(bool) {
        if (bool) {
            this.reset();
        }
        this.data = this.selectAllGuest(this.data, bool);
    }
    getRoleEnable(arr, code) {
        let permissionEnableLevel = [];
        arr.buttonPermissions.forEach((item, index) => {
            if (item.buttonPermissionStatus === 'BUTTON_PERMISSIONS_DISABLED') {
                permissionEnableLevel[index] = { status: 'disable', isAll: false };
            }
            else {
                if (this.$attrs.openMode === 'add') {
                    permissionEnableLevel[index] = { status: false, isAll: false };
                }
                else {
                    permissionEnableLevel[index] = {
                        status: item.buttonPermissionStatus === 'BUTTON_PERMISSIONS_TRUE',
                        isAll: this.isAll(code, this.editData, index),
                    };
                }
            }
        });
        return permissionEnableLevel;
    }
    // 去除0501 生成正确的roleable
    delrole(arr) {
        arr.forEach((item, index) => {
            if (item.subPermissions.length) {
                this.delrole(item.subPermissions);
            }
            item.roleEnables = this.getRoleEnable(item.otherPermissionJson, item.code);
        });
        return arr;
    }
    // 全选guest
    selectAllGuest(arr, bool) {
        arr.forEach((item, index) => {
            if (item.subPermissions.length) {
                this.selectAllGuest(item.subPermissions, bool);
            }
            item.roleEnables.forEach((ele, index) => {
                if (bool) {
                    if (index === 0) {
                        if (ele.status !== 'disable') {
                            ele.isAll = true;
                            ele.status = true;
                        }
                    }
                }
                else {
                    if (ele.status !== 'disable') {
                        ele.isAll = false;
                        ele.status = false;
                    }
                }
            });
        });
        return arr;
    }
    async getPermissionData() {
        this.roleArr = [];
        let mode = this.$attrs.openMode;
        if (mode === 'add') {
            const res = await getPermissionList();
            this.data = this.delrole(res);
        }
        else {
            let editId = this.$attrs.editId;
            this.switchValue = this.$attrs.state === 'ENABLE';
            const res = await getDetailPermissionList(editId);
            if (res) {
                this.roleName = res.name;
                this.editData = res.permissions;
                this.data = this.delrole(res.permissions);
            }
        }
    }
    // 树结构扁平化
    flag(arr) {
        let result = [];
        arr.forEach((item) => {
            let res = JSON.parse(JSON.stringify(item)); // 先克隆一份数据作为第一层级的填充
            delete res['subPermissions'];
            result.push(res);
            if (item.subPermissions instanceof Array && item.subPermissions.length > 0) {
                // 如果当前child为数组并且长度大于0，才可进入flag()方法
                result = result.concat(this.flag(item.subPermissions));
            }
        });
        return result;
    }
    mounted() {
        this.getPermissionData();
    }
    arrayflat(arr) {
        arr.forEach((element) => {
            if (element.subPermissions && Array.isArray(element.subPermissions)) {
                this.arrayflat(element.subPermissions);
            }
            arr.push(element.subPermissions);
        });
        return arr;
    }
    // switch开关事件
    roleSwitch(switchValue) {
        let params = [this.$attrs.editId];
        if (switchValue) {
            enableRole(params)
                .then((res) => {
                this.$message({
                    message: this.$t('openSuccessfully'),
                    type: 'success',
                    customClass: 'zZindex',
                });
                this.$parent?.$parent.getData({});
                this.$parent.searchValue = '';
                this.$parent.statusValue = '';
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
        else {
            disableRole(params)
                .then((res) => {
                this.$message({
                    message: this.$t('ClosedSuccessfully'),
                    type: 'success',
                    customClass: 'zZindex',
                });
                this.$parent?.$parent.getData({});
                this.$parent.searchValue = '';
                this.$parent.statusValue = '';
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
    }
    reset() {
        // (this.$refs.tree as TreeRef)?.setCheckedKeys([]);
        this.data = this.selectAllGuest(this.data, false);
    }
};
__decorate([
    Prop({ default: false })
], default_1.prototype, "addDialogVisible", void 0);
__decorate([
    Watch('addDialogVisible')
], default_1.prototype, "changeAdddialog", null);
default_1 = __decorate([
    Component({
        name: 'RoleAdd',
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    AddRoles: 'Add Roles',
                    editRoles: 'Rights management',
                    detailRoles: 'Role Details',
                    roleNames: 'Role Name',
                    Cancel: 'Cancel',
                    Upload: 'Upload',
                    SelectAll: 'Select All',
                    Input: 'Please input name',
                    DataBoard: 'Data Board',
                    Read: 'Admin',
                    Write: 'System',
                    Option: 'Guest',
                    addSuccessfully: 'Added Successfully',
                    editSuccessfully: 'Edited Successfully',
                    openSuccessfully: 'Open successfully',
                    ClosedSuccessfully: 'Closed successfully',
                    roleName: 'Please enter role name',
                    permission: 'Please select at least one permission',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                },
                zh: {
                    AddRoles: '添加角色',
                    editRoles: '编辑角色',
                    detailRoles: '角色详情',
                    roleNames: '角色名称',
                    Cancel: '取消',
                    Upload: '上传',
                    SelectAll: '全选',
                    Input: '请输入',
                    DataBoard: '数据面板',
                    Read: '普通管理员',
                    Write: '系统管理员',
                    Option: '访客',
                    addSuccessfully: '添加成功',
                    editSuccessfully: '编辑成功',
                    openSuccessfully: '开启成功',
                    ClosedSuccessfully: '关闭成功',
                    roleName: '请输入角色名',
                    permission: '请至少选择一个权限',
                    cancel: '取消',
                    confirm: '确定',
                },
            },
        },
    })
], default_1);
export default default_1;
